import TermlyScriptWrapper from "../components/TermlyScriptWrapper";

const PrivacyPolicyPage = () => {
  return <TermlyScriptWrapper dataId="06fb7a6c-191d-4c07-976a-4d1e765d5fa7" />;
};

export default PrivacyPolicyPage;
